import { format, formatISO, parseISO } from 'date-fns'
import { useMemo } from 'react'
import { useTheme } from '@opallabs/hooks'
import { SelectedDate } from '@opallabs/lapidary'
import { DatePicker } from '@opallabs/satellite'
import { FieldInputProps, DateField } from '../../types'
import { useSwappableField } from '../../useSwappableField'
import { TextDisplay } from '../TextDisplay'
import * as styles from './styles'

const dateDisplayFormat = 'MMM d yyyy'

export const FieldDate = ({
  field,
  onChange,
  readOnly,
  setIsEditing,
  dateOptions = {},
  valueLeadingNode,
}: FieldInputProps<DateField>) => {
  const theme = useTheme()
  const { setDisplayRef, onStopEditing } = useSwappableField({ setIsEditing })

  const date = useMemo(
    () => field.data?.value?.value && parseISO(field.data.value.value),
    [field.data?.value]
  )

  const onSelectDate = (date: SelectedDate) => {
    const value = date ? formatISO(date.dateObject) : null

    onChange({
      fieldId: field.id,
      data: {
        id: field.data?.id || null,
        value: value !== null ? { value } : null,
      },
    })
  }

  if (readOnly) {
    return (
      <TextDisplay
        ref={setDisplayRef}
        fieldId={field.id}
        fieldLabel={field.displayName}
        leadingNode={valueLeadingNode}
        text={date && format(date, dateDisplayFormat)}
        readOnly={readOnly}
        setIsEditing={setIsEditing}
      />
    )
  }

  return (
    <DatePicker
      {...dateOptions}
      buttonCss={styles.buttonStyles(theme)}
      dateDisplayFormat={dateDisplayFormat}
      datePickerDisplayType="button"
      htmlId={`field-${field.id}`}
      onDateSelect={onSelectDate}
      onOpenChange={(open) => (open ? setIsEditing(true) : onStopEditing())}
      placeholder="None"
      selectedDate={date || undefined}
      showButtonText={true}
    />
  )
}
